import { isTrackedAnalyticsHost } from '@/lib/ga-tracked-host'

/** A click starts the Pinterest handoff; it cannot confirm a saved Pin. */
export function trackPinterestSaveInitiated(destination: string, pageFamily: string, hasImage: boolean): void {
  if (typeof window === 'undefined' || !isTrackedAnalyticsHost(window.location.hostname)) return
  if (typeof window.gtag !== 'function') return
  try {
    const url = new URL(destination, 'https://fridge.com')
    window.gtag('event', 'pinterest_save_initiated', {
      page_path: url.pathname,
      page_family: pageFamily,
      has_image: hasImage,
    })
  } catch {
    // Analytics must never prevent the native share link from opening.
  }
}
